import React from "react";
import { FaPause, FaPlay } from "react-icons/fa6";

const PlayPauseButtons = ({ isPlaying, onPlayPause, onSeekBackward, onSeekForward }) => (
  <div className="flex items-center gap-3">
    <button
      onClick={onPlayPause}
      className="transition font-bold"
      aria-label="Play/Pause"
    >
      {isPlaying ? <FaPause size={22} /> : <FaPlay size={20} />}
    </button>
  </div>
);

export default PlayPauseButtons;
